import React from "react";
import { Link } from "react-router-dom";
import "../index.css";

const Navbar = ({ gameLogo, label }) => (
  <nav style={{ position: "relative" }}>
    <span className="logo-left">
      <img
        src={gameLogo}
        alt="Game Logo"
        style={{ display: "inline", maxHeight: "100%" }}
      />
      <span
        style={{
          fontFamily: "Monospace",
          fontSize: "1.7em",
          position: "inherit",
          marginTop: "4px",
          marginLeft: "9px",
          width: "300px",
        }}
      >
        {label}
      </span>
    </span>

    <Link to="https://plaay.nl">
      <img src="/plaay.png" alt="Plaay.nl" className="logo-center" />
    </Link>

    <span className="text-right">
      <Link to="/" style={{ color: "#ccc", textDecoration: "none" }}>
        More games
      </Link>
    </span>
  </nav>
);

export default Navbar;
